import DefaultMenu from './variants/Default';
import NestedMenu from './variants/Nested';

import type {Props} from './types';

interface MenuPropType extends Props {
  value: number;
  indexTab: number;
  width?: string;
}

const Menu = (props: MenuPropType) => {
  return props.value > 3 ? (
    <NestedMenu {...props} />
  ) : (
    <DefaultMenu {...props} />
  );
};

export default Menu;
